import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileAdd = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 13 15",
	width: 13,
	height: 15,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.667 14.667H1.333C.6 14.667 0 14.067 0 13.333V4h1.333v9.333h9.334zM8.333 4V2.667H7V4H5.667v1.333H7v1.334h1.333V5.333h1.334V4zm1.334 4h-4v1.333h4zm-1-8H4c-.733 0-1.327.6-1.327 1.333l-.006 9.334C2.667 11.4 3.26 12 3.993 12h7.34c.734 0 1.334-.6 1.334-1.333V4zm2.666 10.667H4V1.333h4.113l3.22 3.22z"
	})]
});
const ForwardRef = forwardRef(SvgFileAdd);
export { ForwardRef as ReactComponent };
